import BookingIFrame from "@/views/booking/BookingIFrame.vue";
import BookingServiceAvailability from "@/views/booking/BookingServiceAvailability.vue";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { BaseRoutes } from "./base.router";
import { SettingRoutes } from "./settings.router";
import BookingCancelView from "@/views/booking/BookingCancelView.vue";
import BookingUpdateView from "@/views/booking/BookingUpdateView.vue";
import BookingDetailView from "@/views/booking/BookingDetailView.vue";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/bookingiframe",
    name: "BookingIFrame",
    component: BookingIFrame
  },
  {
    path: "/booking",
    name: "BookingServiceAvailability",
    component: BookingServiceAvailability
  },
  {
    path: "/booking/:id",
    name: "BookingDetailView",
    component: BookingDetailView
  },
  {
    path: "/booking/:id/cancel",
    name: "BookingCancel",
    component: BookingCancelView
  },
  {
    path: "/booking/:id/update",
    name: "BookingUpdate",
    component: BookingUpdateView
  }
];
export const BookingRoutes = [...routes];

BaseRoutes.forEach((route: RouteConfig) => {
  routes.push(route);
});

SettingRoutes.forEach((route: RouteConfig) => {
  route.path = "/settings" + route.path;
  routes.push(route);
});

routes.push({
  path: "*",
  name: "BookingHome",
  component: BookingServiceAvailability
});

const router = new VueRouter({
  routes: routes,
  base: "/",
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
